import { BaseEdge, EdgeLabelRenderer, type EdgeProps, getSmoothStepPath } from '@xyflow/react'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { FlowActionDropdown } from 'widgets/Flow'
import { FlowBranchLabel } from 'widgets/Flow/ui/FlowBranchLabel/FlowBranchLabel'
import { FlowBranchAction } from 'widgets/Flow/ui/FlowBranchAction/FlowBranchAction'

import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { AddActionDropdownContent } from './AddActionDropdownContent/AddActionDropdownContent'

export const CustomEdgeWithLabel = observer(
  ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    source,
    target,
  }: EdgeProps & { viewOnly?: boolean }) => {
    const [edgePath] = getSmoothStepPath({
      sourceX,
      sourceY,
      targetX,
      targetY,
      borderRadius: 12,
      centerY: sourceY + 51,
    })

    const { getActionById } = useSmartCallFlowBuilderContext()

    const sourceAction = getActionById(source)

    const [open, setOpen] = useState(false)

    if (!sourceAction) {
      return null
    }

    const branchLabelX = targetX
    const branchLabelY = targetY - 94

    const addButtonX = targetX
    const addButtonY = targetY - 37

    const label = 'brunchLabel' in sourceAction ? sourceAction['brunchLabel'] : ''

    return (
      <>
        <BaseEdge
          id={id}
          path={edgePath}
          style={{
            strokeWidth: 2,
            stroke: 'var(--light-blue-60)',
          }}
        />
        <EdgeLabelRenderer>
          <FlowBranchLabel labelX={branchLabelX} labelY={branchLabelY} label={label || ''} />
          <FlowBranchAction
            labelX={addButtonX}
            labelY={addButtonY}
            open={open}
            onClick={() => setOpen(!open)}
          />

          {open && (
            <FlowActionDropdown
              setOpen={setOpen}
              transform={`translateX(-50%) translate(${addButtonX}px, ${addButtonY + 12}px)`}
              width={231}
              Content={() => (
                <AddActionDropdownContent setOpen={setOpen} target={target} source={source} />
              )}
            />
          )}
        </EdgeLabelRenderer>
      </>
    )
  }
)
